import { render } from "./LinkageIdentification.vue?vue&type=template&id=18edae9b&scoped=true&ts=true"
import script from "./LinkageIdentification.vue?vue&type=script&lang=ts"
export * from "./LinkageIdentification.vue?vue&type=script&lang=ts"

import "./LinkageIdentification.vue?vue&type=style&index=0&id=18edae9b&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src845797062/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18edae9b"]])

export default __exports__